module.exports = __webpack_public_path__ + "img/add-member.1eb3fb07.svg";